'use client';

import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'next-i18next';
import { logger } from '@zep/core-logger';
import { useViewport } from '@/hooks';
import { MAX_QUIZ_COUNT } from '../../constant';
import { useBuildQuestionAlert } from '../../hook/useBuildQuestionAlert';
import { useQuizFormField } from '../EditableQuizCard/hook/useQuizFormField';
import { useQuizList } from '../useQuizList';
import { Drawer } from './Drawer';
import { Modal } from './Modal';
import { useAiGenerateSimilarQuiz } from './useAiGenerateSimilarQuiz';
import { usePromptPresets } from './usePromptPresets';
export const AiGenerateSimilarQuizModal = () => {
  const [isOpen, setIsOpen] = useState(false);
  const {
    quizList
  } = useQuizList();
  const {
    openQuestionCountLimitAlert
  } = useBuildQuestionAlert();
  const handleOpen = useCallback(() => {
    if (quizList.length >= MAX_QUIZ_COUNT) {
      openQuestionCountLimitAlert();
      return;
    }
    setIsOpen(true);
    logger.track('ai_유사문제_오픈');
  }, [quizList.length, openQuestionCountLimitAlert]);
  const handleClose = useCallback(() => {
    setIsOpen(false);
  }, []);
  return <AiGenerateSimilarQuizModalComponent isOpen={isOpen} onOpen={handleOpen} onClose={handleClose} data-sentry-element="AiGenerateSimilarQuizModalComponent" data-sentry-component="AiGenerateSimilarQuizModal" data-sentry-source-file="index.tsx" />;
};
const AiGenerateSimilarQuizModalComponent = ({
  isOpen,
  onOpen,
  onClose
}: {
  isOpen: boolean;
  onOpen: () => void;
  onClose: () => void;
}) => {
  const {
    t
  } = useTranslation(['build']);
  const [question, _] = useQuizFormField({
    field: 'question'
  });
  const {
    handleGenerate,
    handleReset,
    status,
    variables,
    previousPrompt,
    generatedItems,
    handleDeleteItem
  } = useAiGenerateSimilarQuiz({
    question
  });
  const {
    data,
    handleGetPromptPresets
  } = usePromptPresets({
    question
  });
  const prompt = variables?.prompt ?? String(t('build:similarQuiz.modal.promptPlaceholder'));
  const {
    isMobile
  } = useViewport();

  // open, close 될 때 초기화
  useEffect(() => {
    return () => {
      if (!isOpen) {
        handleReset();
        // 닫힐 때 이전 프롬프트 초기화
        previousPrompt.current = '';
      }
    };
  }, [isOpen, handleReset, previousPrompt]);
  if (isMobile) {
    return <Drawer disabled={!question} onGenerate={handleGenerate} isOpen={isOpen} onOpen={onOpen} onClose={onClose} prompt={prompt} items={generatedItems} onRetry={handleReset} status={status} promptPresets={data?.prompts ?? []} previousPrompt={previousPrompt.current ?? ''} onGetPromptPresets={handleGetPromptPresets} onDelete={handleDeleteItem} className="flex mobile-lg:hidden" />;
  }
  return <Modal disabled={!question} onGenerate={handleGenerate} onDelete={handleDeleteItem} onOpen={onOpen} onClose={onClose} prompt={prompt} items={generatedItems} onRetry={handleReset} status={status} promptPresets={data?.prompts ?? []} previousPrompt={previousPrompt.current ?? ''} onGetPromptPresets={handleGetPromptPresets} isOpen={isOpen} className="hidden mobile-lg:flex" data-sentry-element="Modal" data-sentry-component="AiGenerateSimilarQuizModalComponent" data-sentry-source-file="index.tsx" />;
};